import { Controller } from "@hotwired/stimulus";
export default class extends Controller {
  static values = { selectors: String } // expects a comma separated list of selectors

  // Given a selector (e.g. ".additional-details"), reset heights, 
  // determine the tallest element, then assign that height to all.
  matchHeights(selector) {
    this.matchElements(document.querySelectorAll(selector));
  }

  matchElements(elements) {
    if (!elements.length) return;

    let maxHeight = 0;
    elements.forEach(el => {
      el.style.height = "auto";
      maxHeight = Math.max(maxHeight, el.offsetHeight);
    });

    elements.forEach(el => {
      el.style.height = `${maxHeight}px`;
    });
  }

  // Rows that share a data-match-heights-row index get the same height across cards.
  matchRows() {
    const rows = {};
    this.element.querySelectorAll("[data-match-heights-row]").forEach(el => {
      const index = el.dataset.matchHeightsRow;
      rows[index] = rows[index] || [];
      rows[index].push(el);
    });
    Object.values(rows).forEach(elements => this.matchElements(elements));
  }

  // Rows come first, so a section that holds them is measured after they grow.
  matchAll() {
    this.matchRows();
    if (!this.hasSelectorsValue) return;
    const selectors = this.selectorsValue.split(",").map(s => s.trim());
    selectors.forEach(selector => this.matchHeights(selector));
  }

  connect() {
    this.matchAll();
    this.onResize = debounce(() => {
      this.matchAll();
    }, 200);
    window.addEventListener("resize", this.onResize);
  }

  disconnect() {
    window.removeEventListener("resize", this.onResize);
  }
}